import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import '../App.css';
import BasicDetails from './BasicDetails';
import Questions from './Questions';

class Survey extends Component {
  render() {
    return (
      <div className='container'>
        {this.props.StateStore.route === 'home' ? (
          <BasicDetails />
        ) : (
          <Questions />
        )}
      </div>
    );
  }
}

export default inject('StateStore')(observer(Survey));
